import { CHAT_TYPE } from "@/types/navigation-mode";

export const tabList = [
  {
    name: "chat_tab_navigate",
    placeholder: "chat_nav_placeholder",
    type: CHAT_TYPE.NAVIGATION,
  },
  {
    name: "chat_tab_simulation",
    placeholder: "chat_sim_placeholder",
    type: CHAT_TYPE.SIMULATION,
  },
  {
    name: "chat_tab_exploration",
    placeholder: "chat_nav_placeholder",
    type: CHAT_TYPE.EXPLORATION,
  },
];
